import { process } from "@progress/kendo-data-query";
import { setGroupIds } from "@progress/kendo-react-data-tools";

export const processWithGroups = (data, dataState) => {
  const newDataState = process(data, dataState);
  setGroupIds({ data: newDataState.data, group: dataState.group });
  return newDataState;
};
